import { render, staticRenderFns } from "./captain_bonus_types.vue?vue&type=template&id=287556f2&scoped=true&"
import script from "./captain_bonus_types.vue?vue&type=script&lang=js&"
export * from "./captain_bonus_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287556f2",
  null
  
)

export default component.exports